import { graphql } from "@/api/graphql/types/gql";

export const SearchLedgersStatus = graphql(`
  query SearchLedgersStatus($request: LedgersMsSearchStatusesRequest!) {
    LedgersMsSearchStatuses(request: $request) {
      data {
        id
        code
        canCreateCopy
      }
    }
  }
`);

export const SearchLedgersListQuery = graphql(`
  query SearchLedgers($request: LedgersMsSearchLedgersRequest!) {
    LedgersMsSearchLedgers(request: $request) {
      data {
        id
        rank
        originalName
        registrationNumber
        name
        statusId
        typeId
        pan
        shortCode
        evId
        SectorIdData {
          id
          label
        }
        isElectricPackage
        tollPackageCode
        fuelPackageCode
        nextLedgerId
        renewalCancellable
        isModifiable
        WalletIdData {
          id
          SettingsIdData {
            divisionAccountNumber
            divisionAccountLabel
            supportAccountLabel
            supportAccountNumber
            sectorId
          }
        }
        pcomType
        expiresTs
        complementaryInfo
        LastOpenOrderIdData {
          type
        }
        StatusIdData {
          code
          blockable
          id
          deletable
        }
        canCreateCopy
        TypeIdData {
          id
          code
          GroupIdData {
            codeHint
            code
          }
        }
        isPinResendable
        isPinRequestActive
      }
      pagination {
        page
        size
        total
      }
    }
  }
`);

export const CountLedgersByStatusQuery = graphql(`
  query CountLedgersByStatus($request: LedgersMsCountLedgersByStatusRequest!) {
    LedgersMsCountLedgersByStatus(request: $request) {
      metrics {
        statusCode
        statusId
        total
        ledgerTypeMetrics {
          type
          total
        }
      }
    }
  }
`);

export const LedgersMsSearchLedgersQuery = graphql(`
  query LedgersMsSearchLedgers($request: LedgersMsSearchLedgersRequest!) {
    LedgersMsSearchLedgers(request: $request) {
      data {
        id
        name
        pcomType
        TypeIdData {
          id
          codeHint
          code
          GroupIdData {
            code
            codeHint
          }
        }
        WalletIdData {
          id
          SettingsIdData {
            supportAccountLabel
            divisionAccountLabel
          }
          label
          originalLabel
        }
      }
    }
  }
`);

export const GetOrderableWalletLedgerTypesQuery = graphql(`
  query LedgersMsGetOrderableWalletLedgerTypes(
    $request: LedgersMsGetOrderableWalletLedgerTypesRequest
  ) {
    LedgersMsGetOrderableWalletLedgerTypes(request: $request) {
      data {
        GroupIdData {
          category
          code
          codeHint
          id
        }
        code
        codeHint
        groupId
        id
      }
    }
  }
`);
